import script from "./AutofillFieldChoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutofillFieldChoices.vue?vue&type=script&setup=true&lang=ts"

import "./AutofillFieldChoices.vue?vue&type=style&index=0&id=40864ae9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40864ae9"]])

export default __exports__